export default "__VITE_ASSET__Cd2j3LQ___"